// سيقوم هذا الكود بجلب النطاق (Host) الذي يعمل عليه التطبيق حالياً
// إذا فتحت من الكمبيوتر سيكون localhost، وإذا فتحت من الموبايل سيكون 192.168.1.106
 export const API_BASE_URL = `https://${window.location.hostname}/api`;
// config.js
// export const API_BASE_URL = `http://${window.location.hostname}:8000/api`;
